import { setLocalePath } from "@/locales/index";
export const locale_file_path = "common.";
const text = {
    app: "허브컨트롤룸",
    map_control_header_title: "지도관제",
    success: "성공",
    fail: "실패",
    invalid_access: "잘못된 접근입니다.",
    text_title: "제목",
    text_body: "내용",
    ok: "확인",
    no: "취소",
    cancel: "취소",
    registration: "등록",
    publish: "발행",
    alert: "알림",
    search: "검색",
    apply: "적용",
    not_applied: "적용 안 함",
    delay: "지연",
    done: "완료",
    complete: "완료",
    change: "변경",
    remove: "삭제",
    delete: "삭제",
    modify: "수정",
    edit: "수정",
    save: "저장",
    add: "추가",
    drawer_settings: "설정",
    all: "전체",
    phone: "전화",
    reserved: "예약",
    accepted: "접수",
    allocated: "배차",
    reallocated: "재배차",
    worker_requested: "배차요청",
    worker_requested_cancel: "배차요청취소",
    allocate_rejected: "배차거절",
    immediate_allocate: "즉시배차",
    settled: "마감",
    pickup: "픽업",
    question: "문의",
    waited: "대기",
    wait_end: "대기해제",
    allocate_cancel: "배차취소",
    order_modify: "수정",
    re_accept: "재접수",
    reserve_end: "예약해제",
    self: "자체",
    self_delivery: "자체",
    order_reject: "주문거절",
    priority_allocate: "가배차",
    priority_allocate_cancel: "가배차취소",
    order: "주문",
    self_delivering: "자체배달중",
    self_drop_finished: "자체완료",
    search_placeholder: "검색어를 입력해 주세요.",
    quick: "퀵",
    quick_service: "퀵서비스",
    before_change: "변경 전",
    after_change: "변경 후",
    area: "구역",
    fold: "접기",
    share: "공유",
    riderName: "라이더명",
    status: "상태",
    currency: "원",
    untact: "비대면",
    untact_short: "비",
    on: "출근",
    off: "퇴근",
    waiting: "대기",
    driving: "운행",
    rest: "휴식",
    card: "카드",
    pre_payment: "선결제",
    on_site_payment: "도착지결제",
    on_site_quick_payment: "착불",
    pre_quick_payment: "선불",
    km: "km",
    pickup_arrived: "픽업 도착",
    pickup_finished: "픽업",
    drop_finished: "완료",
    hub_selection: "허브 선택",
    selection_confirm: "선택완료",
    drawer_dashboard: "대쉬보드",
    drawer_delivery_history: "배달내역",
    drawer_worker_management: "라이더관리",
    drawer_store_management: "상점관리",
    drawer_hub_settings: "허브관리",
    drawer_notice: "공지사항",
    drawer_customer_support: "고객지원(채팅상담)",
    login: "로그인",
    logout: "로그아웃",
    history: "상세이력 자세히 보기",
    changed: "변경되었습니다.",
    auth_verification: "본인 인증",
    phone_number: "전화번호",
    auth_verification_number: "인증번호",
    request_auth_verification: "인증요청",
    send_auth_verification: "인증확인",
    request_auth_verification_message: "인증요청이 완료되었습니다.",
    send_auth_verification_message: "인증확인이 완료되었습니다.",
    clip_success: "복사가 완료되었습니다.",
    clip_failure: "다시 시도해 주세요.",
    select_all: "전체선택",
    previous: "이전",
    next: "다음",
    failure: "오류가 발생했습니다.",
    timeouted: "데이터를 불러오는데 실패했습니다. 다시 시도해주세요.",
    delivery_forbidden: "해당 배달 상세정보 보기 권한이 없습니다.",
    memo: "특이사항",
    prefix_elapsed_time: "경과시간 {elapsedTime}",
    suffix_elapsed_time: "{elapsedTime} 경과",
    prefix_remaining_time: "남은시간 {remainingTime}",
    suffix_remaining_time: "{remainingTime} 남음",
    negative_suffix_remaining_time: "{remainingTime} 지연",
    minutes: "분",
    hours: "시간",
    second_suffix: "{second}초",
    minutes_suffix: "{minutes}분",
    hours_suffix: "{hours}시간",
    use: "사용",
    no_use: "사용 안 함",
    no_limit: "제한 없음",
    count: "건",
    above_count: "건 이상",
    count_suffix: "{count}건",
    amount_required: "금액 입력",
    percent_required: "퍼센트 입력",
    selection: "선택",
    select_period_header_title: "조회 기간",
    available: "가능",
    not_available: "불가능",
    hub_type: {
        all: "전체",
        own: "자사",
        share: "공유",
        b2b: "B2B",
    },
    pay_type: {
        all: "전체",
        pay_cash: "현금",
        pay_card: "카드",
        pre_pay: "선결제",
    },
    order_type: {
        all: "전체",
        delivery: "배달",
        quick: "퀵",
    },
    back_to_list: "목록보기",
    go_back: "뒤로가기",
    search_field_placeholder: "{field} 검색",
    input_field_placeholder: "{field} 입력",
    select_field_placeholder: "{field} 선택",
    input_field_by_setting_placeholder: "{field} 설정",
    on_fetching: "데이터를 불러오는 중입니다.",
    data_can_not_load: "일시적인 오류로 데이터를 불러오지 못했습니다.",
    form_validation_error: "필수 입력 정보를 확인해 주세요.",
    unknown_error: "일시적 오류가 발생했습니다. 다시 시도해주세요.",
    confirm_before_cancel: "취소하시면 입력하신 정보가 저장되지 않습니다.\n그만하시겠습니까?",
    confirm_before_cancel_edit: "입력중인 내용이 있습니다.\n그만하시겠습니까?",
    confirm_before_delete_for_selected_item: "선택한 항목을 삭제하시겠습니까?",
    confirm_before_delete_title: "{item} 삭제",
    confirm_before_delete: "삭제하시겠습니까?",
    id_pattern_hint: "* 한글, 영문 대소문자, 숫자, 특수문자만 사용 가능합니다.",
    password_pattern_hint: "* 영문 대문자, 소문자, 숫자, 특수문자 2가지 이상 조합하여 10자리 이상으로 사용 가능합니다.",
    no_report_data_text: "정산 데이터가 없습니다.",
    multiple_selected: "여러날짜 선택함",
    year_month_day: "{yearInfo}년 {monthInfo}월 {dayInfo}일",
    no_data_text: "데이터가 없습니다.",
    no_search_data_text: "검색결과가 없습니다.",
    week_type_code: {
        full_text: [
            "월요일",
            "화요일",
            "수요일",
            "목요일",
            "금요일",
            "토요일",
            "일요일",
        ],
        shorten_text: [
            "월",
            "화",
            "수",
            "목",
            "금",
            "토",
            "일",
        ],
    },
    delivery_pay_type: {
        pay_cash: "현금",
        pay_baromoney: "바로머니",
        customer_pay: "고객",
    },
    surcharge_type: {
        weater: "기상악화",
        holiday: "휴일",
        busy: "배달폭주",
        time: "시간",
        late_night: "심야",
        etc: "기타",
        area: "구역",
        overload: "과적",
        valuable: "귀중",
        distance: "거리",
        none: "없음",
    },
    register: "등록",
    unregistered: "미등록",
    done_with_registration: "등록완료",
    not_use: "사용 안 함",
    unaccepted: "허용 안 함",
    delay_time: "{time}분 지연",
    bulletin_good: "원활",
    bulletin_stop: "중단",
    delivery_status: "수행상황",
    fax: "팩스번호",
    address_detail: "상세주소",
    bank: "은행",
    bank_account_owner: "예금주",
    bank_account: "계좌번호",
    name: "이름",
    cell_phone_number: "휴대폰번호",
    email: "이메일",
    headquarter: "본사",
    distributor: "총판",
    hub: "허브",
    reset: "초기화",
    reset_search: "검색 초기화",
    type: "유형",
    search_word: "검색어",
    store_name: "상점명",
    unit: "단건",
    bundle: "묶음",
    select_period: "조회 기간",
    supply_info: "공급 정보",
    provider: "공급자",
    consumer: "공급받는 자",
    supply_info_dialog_title: "{title} 공급 정보",
    delivery_charge: "배달대행료",
    download: "내역 다운로드",
    yogi_delivery: "요기배달",
    yogi_delivery_acronym: "요기요",
    baemin_one: "배민배달",
    baemin_one_acronym: "배민",
    o2plus_for_address: "오투플러스",
    o2plus_for_address_acronym: "오투",
    invoicer: "공급자",
    invoicee: "공급받는 자",
    search_post_code: {
        detail_address: "상세주소",
        change_address_dialog_title: "주소 변경",
        search_post_code: "주소 검색",
        postcode_detail_input_label: "상세 주소 입력",
        not_changed_drop_address: "기존 주소와 동일합니다.",
        kakao_map_error: "카카오 주소 오류입니다. 잠시 후 시도해주세요.",
    },
    confirm_cancel_message: "취소하시면 입력하신 정보가 저장되지 않습니다.\n그만하시겠습니까?",
    reply: "답변",
    success_request: "배차요청 성공",
    success_allocate: "즉시배차 성공",
    success_reallocate: "재배차 성공",
};
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const autoLcCommon = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default text;
